'use client';
import React, { forwardRef } from 'react';
import Button from '@pezeshk-book/ui-kit/button';
import { useSelector } from 'react-redux';
import { CommentFormProps } from './comment-form.props';
import { RootState } from '@store/root-reducer';
import SubmitForm from '@modules/comment/comment-form/submit-form';

export const CommentForm = forwardRef<any, CommentFormProps>(function CommentForm(props, ref) {
  const { submitHandler, directHandler, onChange, loginHandler, commentValue, submitLoading, parentName, hasScore, score, scoreCallBack } = props;
  const { isLoggedIn } = useSelector((state: RootState) => state.auth);

  if (!isLoggedIn) {
    return (
      <Button
        onClick={loginHandler}
        className={'my-4'}>
        برای ثبت نظر ابتدا وارد شوید
      </Button>
    );
  }

  return (
    <SubmitForm
      hasScore={hasScore}
      scoreCallBack={scoreCallBack}
      score={score}
      ref={ref}
      submitHandler={submitHandler}
      directHandler={directHandler}
      onChange={onChange}
      commentValue={commentValue}
      submitLoading={submitLoading}
      parentName={parentName}
    />
  );
});

export default CommentForm;
